<template>
  <div class="loadingScreen" :class="{'active':active, 'visible': value }"  @click.stop>
  <svg width="72" height="16" viewBox="0 0 72 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="4" fill="#E9041E">
      <animate 
        attributeName="r" 
        values="4;4;8;4;4"
        dur="1500ms"
        repeatCount="indefinite" />
    </circle>
    <circle id="c2" cx="38" cy="8" r="4" fill="#E9041E">
      <animate 
        attributeName="r" 
        values="4;4;8;4;4"
        begin="150ms"
        dur="1500ms"
        repeatCount="indefinite" />
    </circle>
    <circle id="c3" cx="64" cy="8" r="4" fill="#E9041E">
      <animate 
        attributeName="r" 
        values="4;4;8;4;4"
        dur="1500ms"
        begin="300ms"
        repeatCount="indefinite" />
    </circle>
    </svg>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$el.remove()
    document.body.append(this.$el)
    this.slowvalue = this.value
  },
  props: {
    value: Boolean,
    active: Boolean
  },
  watch:{
    value(v){
      if (v) 
        document.activeElement.blur()
    }
  },
  
}
</script>

<style lang="sass">
.loadingScreen
  pointer-events: none
  opacity: 0
  position: fixed
  transition: transform .4s ease
  &:not(.active)
    transform: translateX(100%)
  &.visible
    opacity: 1
    pointer-events: auto
  top: 0
  right: 0
  width: 688px
  max-width: 100%
  bottom: 0
  z-index: 50
  background: rgba(255,255,255,.7)
  display: flex
  justify-content: center
  align-items: center
  *
    transition: 0s !important
    transition-delay: 0s !important
</style>